export default "__VITE_ASSET__4715f017__"